// automatically generated by the FlatBuffers compiler, do not modify
export var CompressionType;
(function (CompressionType) {
    CompressionType[CompressionType["LZ4_FRAME"] = 0] = "LZ4_FRAME";
    CompressionType[CompressionType["ZSTD"] = 1] = "ZSTD";
})(CompressionType || (CompressionType = {}));

//# sourceMappingURL=compression-type.mjs.map
